if (document.getElementById('vue-residence')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin ],
		el: '#vue-residence',
		data: {
			displayModal3d: false,
      displayCarousel: false,
      carousel: null,
			srcIframe: '',
			residences: []
		},
		mounted() {
			this.getResidences();
		},
		methods: {
			getResidences() {
				this.get('residences', { site: window.site_id }, false)
					.then((response) => {
						this.residences = response.data.results;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			openModal(url) {
				this.displayModal3d = true;
				this.srcIframe = url;
      },
      openCarousel(index = 0) {
        console.log(index)
        if (!this.carousel) {
          this.carousel = tns({
              container: '.js-carousel-residence',
              autoplayButtonOutput: false,
              mode: 'gallery',
              navAsThumbnails: true,
              items: 1,
              speed: 500,
              autoplay: false,
              mouseDrag: true,
              touch: true,
              controlsContainer: '.js-controls-residence',
              nav: false
            });
        }
        this.carousel.goTo(index)
				this.displayCarousel = true;
			}
		}
	});
}
